// angular
// 	.module("HeroPRO")
// 	.factory("TrainingFactory", trainingFactory);

import _ from 'lodash';

/* @ngInject */
export default function trainingFactory($http, $q, HPConfig, HPTrainingType) {
    return {
        getPages,
        getContractorType,
        complete,
    };

    function getPages(type) {
        const questions = $q((resolve) => {
            getQuestions(type).then((response) => {
                const q =
                    {
                        TrainingModule: response.TrainingModule,
                        ContractorTrainingId: response.ContractorTrainingId,
                        Topics: [],
                    };

                for (let y = 0; y < response.Topics.length; y++) {
                    q.Topics.push({
                        ContractorTrainingTopicId: response.Topics[y].ContractorTrainingTopicId,
                        TemplateName: response.Topics[y].Topic,
                        templateUrl: `app/notificationCenter/modal/training/${formatTemplateName(response.Topics[y].Topic)}/${formatTemplateName(response.Topics[y].Topic)}.html`,
                        Questions: response.Topics[y].Questions,
                        SectionNumber: response.Topics[y].SectionNumber,
                        Answers: response.Topics[y].Answers,
                        CorrectAnswer: response.Topics[y].CorrectAnswer,
                        SelectedAnswer: null,
                        IsCurrent: y === 0,
                        prev: y === 0 || y === 1 ? null : response.Topics[y - 1].Topic,
                        next: y === response.Topics.length - 1 || y + 1 > response.Topics.length - 1 ? null : response.Topics[y + 1].Topic,
                    });
                }

                addTrainingComplete(q);

                resolve(q);
            });
        });

        return questions;
    }

    function complete() {
        const result = $q((resolve, reject) => {
            $http.post(`${HPConfig.heroProApi}ActionItem/CompleteTrainingActionItem`).then((response) => {
                resolve(response);
            }, (error) => {
                reject(error);
            });
        });

        return result;
    }

    function getContractorType(userLocations) {
        return $q.when(userLocations, locations => processLocations(locations));
    }


    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    function getQuestions(type) {
        const results = $q((resolve) => {
            $http.get(`${HPConfig.heroProApi}Contractor/GetContractorTrainingProduct`, { params: { ModuleType: type } }).then((response) => {
                const data = response.data.Data;
                
                const qS =
                {
                    ContractorTrainingId: 0,
                    TrainingModule: null,
                    Topics: [],
                };
                qS.ContractorTrainingId = data.ContractorTrainingId;
                qS.TrainingModule = data.Name;

                _.each(data.Topics, (t) => {
                    qS.Topics.push({
                        Topic: t.TemplateName,
                        SectionNumber: t.ContractorTrainingProductModuleId,
                        ContractorTrainingTopicId: t.ContractorTrainingTopicId,
                        Questions: !!t.Questions ? { Question: t.Questions[0].Question, ContractorTrainingQuestionId: t.Questions[0].ContractorTrainingQuestionId, IsActive: t.Questions[0].IsActive } : null,
                        Answers: !!t.Questions && t.Questions[0].Answers ? t.Questions[0].Answers : null,
                        CorrectAnswer: !!t.Questions && t.Questions[0].Answers ? _.find(t.Questions[0].Answers, a => a.IsCorrectResponse === true) : null,
                    });
                });

                resolve(qS);
            });
        });

        return results;
    }

    function formatTemplateName(name) {
        return name.charAt(0).toLowerCase() + name.slice(1);
    }

    function addTrainingComplete(trainings) {
        trainings.Topics[trainings.Topics.length - 1].next = 'complete';
        trainings.Topics.push({
            ContractorTrainingTopicId: null,
            TemplateName: 'complete',
            templateUrl: 'app/notificationCenter/modal/training/complete/complete.html',
            Questions: [],
            Answers: [],
            CorrectAnswer: [],
            SelectedAnswer: null,
            IsCurrent: false,
            onEnter() { return complete(); },
            prev: trainings.Topics[trainings.Topics.length - 1].Topic,
            next: null,
        });
    }

    function processLocations(locations) {
        let isHero = null;
        let isBenji = null;
        let type = HPTrainingType.BENJI;
        // const users = _.filter(locations, u => u.hasOwnProperty('FinancingProducts'));

        // _.each(users, (value) => {
        //     if (!isHero && _.contains(value.FinancingProducts, 'HERO')) {
        //         isHero = true; // _.contains(value, "HERO");
        //     }
        //     if (!isBenji && _.contains(value.FinancingProducts, 'BENJI')) {
        //         isBenji = true; // _.contains(value, "BENJI");
        //     }
        // });

        // if (!isHero && isBenji) {
        //     type = HPTrainingType.BENJI;
        // } else if (isHero && !isBenji) {
        //     type = HPTrainingType.HERO;
        // }

        return type;
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/trainingFactory.js